import { fetchPOI } from '../helpers/api_helpers';

export type POIType = "point"|"bus_stop"|"commerce"|"hotel"|"my_location"|"food"|"text"|"vl"|"region";
export let poi_types = ["point", "bus_stop", "commerce", "hotel", "my_location", "food", "text", "vl", "region"];
export interface POI {
    id: number;
    type: POIType;
    position: {
        crs: "wgs84";
        x: number;
        y: number;
        z?: number;
    };
    name?: string;
    description?: string;
}
export interface POIset {
    id: number;
    poi_ids: number[];
}
export interface NewPOI {
    type: POIType;
    position: {
        crs: "wgs84";
        x: number;
        y: number;
    };
    name: string;
}
// let example_poi: POI[] = [
//     {
//         id: 1,
//         type: "point",
//         name: "POI 1",
//         position: {
//             crs: "wgs84",
//             x: 15.8867,
//             y: 59.132
//         }
//     },
//     {
//         id: 2,
//         type: "hotel",
//         name: "POI Hotel 2",
//         position: {
//             crs: "wgs84",
//             x: 16.120813,
//             y: 59.5300
//         }
//     }
// ];

export function fetchPOISet(set_id: number) {
    return fetchPOI(set_id);
}



// WEBPACK FOOTER //
// ./src/helpers/poi_helpers.ts